import { render, staticRenderFns } from "./SuggestionsListView.vue?vue&type=template&id=235480a8&"
import script from "./SuggestionsListView.vue?vue&type=script&lang=js&"
export * from "./SuggestionsListView.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionsListView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports